/*
 * @Descripttion: 客户回款明细页面
 * @Author: 曹博
 * @Date: 2023-09-22 08:30:29
 * @LastEditors: 曹博
 * @LastEditTime: 2023-09-26 11:07:07
 */
import { Button, Form, Input, Select, Spin } from 'antd'
import UsePaymentDetailsHook from './hooks'
import Styles from './paymentDetails.module.scss'
import TableAntd from '../../components/TableAntd'

const PaymentDetails = () => {
  const { form, state, resetHandler, searchHandler, onFieldsChange } =
    UsePaymentDetailsHook()
  const { platformList, dataSource, loading } = state

  const columns = [
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'customer',
      dataIndex: 'customer',
      title: '客户名称',
    },
    {
      key: 'allSalesAmount',
      dataIndex: 'allSalesAmount',
      title: '总销售金额',
    },
    {
      key: 'allRefundPrice',
      dataIndex: 'allRefundPrice',
      title: '已回款金额',
    },
    {
      key: 'unRefundPrice',
      dataIndex: 'unRefundPrice',
      title: '未回款金额',
    },
  ]

  return (
    <Spin tip="报表努力生成中，请稍后……" spinning={loading} size="large">
      <div className={Styles['container']}>
        <div className={Styles['search-filter']}>
          <Form form={form} layout="inline" onFieldsChange={onFieldsChange}>
            <Form.Item name="platform" label="下单平台">
              <Select
                showSearch
                allowClear
                placeholder="请选择"
                optionFilterProp="label"
                options={platformList}
                style={{ width: '170px' }}
              />
            </Form.Item>
            <Form.Item name="customer" label="客户名称">
              <Input placeholder="请输入" onPressEnter={searchHandler}></Input>
            </Form.Item>
          </Form>
          <Button style={{ margin: '0 12px 0 24px' }} onClick={resetHandler}>
            重置
          </Button>
          <Button type="primary" onClick={searchHandler}>
            查询
          </Button>
        </div>
        <div className={Styles['table-container']}>
          <TableAntd
            selfAdaptScroll
            dataSource={dataSource}
            listColumn={columns}
            loading={false}
            showSize
          ></TableAntd>
        </div>
      </div>
    </Spin>
  )
}

export default PaymentDetails
/*
 * @Descripttion: 客户回款明细页面
 * @Author: 曹博
 * @Date: 2023-09-22 08:30:29
 * @LastEditors: 曹博
 * @LastEditTime: 2023-09-26 11:07:07
 */
import { Button, Form, Input, Select, Spin } from 'antd'
import UsePaymentDetailsHook from './hooks'
import Styles from './paymentDetails.module.scss'
import TableAntd from '../../components/TableAntd'

const PaymentDetails = () => {
  const { form, state, resetHandler, searchHandler, onFieldsChange } =
    UsePaymentDetailsHook()
  const { platformList, dataSource, loading } = state

  const columns = [
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'customer',
      dataIndex: 'customer',
      title: '客户名称',
    },
    {
      key: 'allSalesAmount',
      dataIndex: 'allSalesAmount',
      title: '总销售金额',
    },
    {
      key: 'allRefundPrice',
      dataIndex: 'allRefundPrice',
      title: '已回款金额',
    },
    {
      key: 'unRefundPrice',
      dataIndex: 'unRefundPrice',
      title: '未回款金额',
    },
  ]

  return (
    <Spin tip="报表努力生成中，请稍后……" spinning={loading} size="large">
      <div className={Styles['container']}>
        <div className={Styles['search-filter']}>
          <Form form={form} layout="inline" onFieldsChange={onFieldsChange}>
            <Form.Item name="platform" label="下单平台">
              <Select
                showSearch
                allowClear
                placeholder="请选择"
                optionFilterProp="label"
                options={platformList}
                style={{ width: '170px' }}
              />
            </Form.Item>
            <Form.Item name="customer" label="客户名称">
              <Input placeholder="请输入" onPressEnter={searchHandler}></Input>
            </Form.Item>
          </Form>
          <Button style={{ margin: '0 12px 0 24px' }} onClick={resetHandler}>
            重置
          </Button>
          <Button type="primary" onClick={searchHandler}>
            查询
          </Button>
        </div>
        <div className={Styles['table-container']}>
          <TableAntd
            selfAdaptScroll
            dataSource={dataSource}
            listColumn={columns}
            loading={false}
            showSize
          ></TableAntd>
        </div>
      </div>
    </Spin>
  )
}

export default PaymentDetails
